import { classNames } from 'uitk-react-utils';
import { UitkCheckbox } from 'uitk-react-switch';
import { UitkPrimaryButton, UitkTertiaryButton } from 'uitk-react-button';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { ReviewsFilterOptionsModel } from 'models/common';

export interface ReviewsFilterOptionsProps {
  showButtons?: boolean;
  checkboxOptions: ReviewsFilterOptionsModel[];
  className?: string;
  applyOptionsCallback?: (values: string[] | number[]) => void;
  label?: string;
  toggleSheet?: () => void;
}

export interface ReviewsFilterOptionsState {
  options: object;
}

export class ReviewsFilterOptions extends React.Component<ReviewsFilterOptionsProps, ReviewsFilterOptionsState> {
  public constructor(props) {
    super(props);
    const { checkboxOptions } = this.props;
    const options = checkboxOptions ? this.createOptionsModel(checkboxOptions) : [];
    this.state = {
      options
    };

    this.clearSelectedFilters = this.clearSelectedFilters.bind(this);
    this.applySelectedFilters = this.applySelectedFilters.bind(this);
    this.handleOptionSelect = this.handleOptionSelect.bind(this);
  }

  private createOptionsModel(options: ReviewsFilterOptionsModel[]): object {
    const optionsModel = {};
    options.map(option => (optionsModel[option.value] = option.selected));

    return optionsModel;
  }

  private clearSelectedFilters(): void {
    const { options } = this.state;
    const optionsModel = {};
    Object.keys(options).forEach(option => (optionsModel[option] = false));

    this.setState({
      options: optionsModel
    });
  }

  private applySelectedFilters(): void {
    const { options } = this.state;
    const { applyOptionsCallback } = this.props;
    const selectedValues = [];

    for (const key in options) {
      if (options.hasOwnProperty(key)) {
        if (options[key] === true) {
          selectedValues.push(key);
        }
      }
    }

    applyOptionsCallback(selectedValues);
  }

  private handleOptionSelect(value: string | number): void {
    const { showButtons } = this.props;
    const currentSelectionState = this.state.options[value];
    const selectCallback = showButtons ? null : this.applySelectedFilters;

    this.setState(
      {
        options: {
          ...this.state.options,
          [value]: !currentSelectionState
        }
      },
      selectCallback
    );
  }

  public render() {
    const { label, checkboxOptions, showButtons, className } = this.props;
    const { options } = this.state;
    const filterOptionsClasses = classNames('all-t-padding-four s-x-padding-four', className);
    const ClearButtonTracked = ClickTracker(UitkTertiaryButton);
    const ApplyButtonTracked = ClickTracker(UitkPrimaryButton);

    return (
      <div className={filterOptionsClasses}>
        {label && <div className="uitk-type-bold uitk-type-heading-500 all-b-padding-two">{label}</div>}
        <FilterOptions checkboxOptions={checkboxOptions} checkboxOptionsState={options} handleOptionSelect={this.handleOptionSelect} />
        {showButtons && (
          <div className="uitk-grid all-cell-1-1 all-b-padding-four">
            <div className="uitk-cell uitk-type-right all-t-padding-two">
              <ClearButtonTracked
                className="uitk-type-right"
                text="Clear"
                onClick={this.clearSelectedFilters}
                rfrr="Reviews.FilterClear"
                linkName="Reviews Filter Clear"
              />
              <ApplyButtonTracked
                className="uitk-type-right"
                text="Apply"
                onClick={this.applySelectedFilters}
                rfrr="ReviewsFilterApply"
                linkName="Review Filters Apply"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export interface FilterOptionsProps {
  checkboxOptions: ReviewsFilterOptionsModel[];
  checkboxOptionsState?: object;
  handleOptionSelect?: (value: string | number) => void;
}

export const FilterOptions: React.FunctionComponent<FilterOptionsProps> = props => {
  const { checkboxOptions, checkboxOptionsState, handleOptionSelect } = props;

  const OptionTracked = ClickTracker(UitkCheckbox);

  return (
    <>
      {checkboxOptions.map((option, index) => {
        const optionListener = () => handleOptionSelect(option.value);

        return (
          <div key={index} className="uitk-type-300 pwa-theme--grey-700">
            <OptionTracked
              id={option.label}
              label={option.label}
              checked={checkboxOptionsState[option.value]}
              onChange={optionListener}
              rfrr={`Reviews.Filter.${option.trackingId}`}
              linkName="Reviews Filter Rating"
            />
          </div>
        );
      })}
    </>
  );
};
FilterOptions.displayName = 'FilterOptions';
